export default "__VITE_ASSET__nMEfhQ4L__"